<app-header *ngIf="showHead"></app-header>
<app-sidebar *ngIf="showSider"></app-sidebar>
<!-- <app-background></app-background> -->
<div [ngClass]="loggedInCls? 'loggedIn': 'fullpage-background'">
    <!-- <div class="test"> -->
    <router-outlet></router-outlet>
    <!-- </div> -->
</div>